<span class="status-badge"
    [class.status-badge-draft]="status === 1"
    [class.status-badge-pending]="status === 2"
    [class.status-badge-in-progress]="status === 3"
    [class.status-badge-signed]="status === 4"
    [class.status-badge-rejected]="status === 5"
    [class.status-badge-canceled]="status === 6"
    >
    {{ statusText }}
</span>